<script lang="ts">
    import { _ } from "svelte-i18n"
</script>

<style lang="less">
    #dateModal {
        position: absolute;
        z-index: 9999;
        background-color: white;
        display: none;
    }

    #dateDeleteValidationModal,
    #followUpDeleteValidationModal {
        position: absolute;
        z-index: 9999;
        background-color: white;
        display: none;
        flex-direction: column;
        gap: 10px;
        padding: 12px;
        width: 236px;
        .question {
            padding: 0px;
            margin: 0px;
            font-size: 12px;
        }
        .bottom {
            display: flex;
            justify-content: space-between;
            .cancel,
            .delete {
                padding: 0px;

                cursor: pointer;
                background-color: transparent;
                border: none;
                font-size: 12px;
            }
            .cancel {
                color: var(--stategrey);
            }
            .delete {
                color: var(--renzrot);
            }
        }
    }
</style>

<div id="dateModal"></div>

<div id="dateDeleteValidationModal">
    <p class="question">{$_("components.date.dateDeleteValidationModal.question")}</p>
    <div class="bottom">
        <button class="cancel">{$_("components.date.dateDeleteValidationModal.cancelButton")}</button>
        <button class="delete">{$_("components.date.dateDeleteValidationModal.deleteButton")}</button>
    </div>
</div>

<div id="followUpDeleteValidationModal">
    <p class="question">{$_("components.date.followUpDeleteValidationModal.question")}</p>
    <div class="bottom">
        <button class="cancel">{$_("components.date.followUpDeleteValidationModal.cancelButton")}</button>
        <button class="delete">{$_("components.date.followUpDeleteValidationModal.deleteButton")}</button>
    </div>
</div>
